import { TSystemSettingValueCommon, TSystemSettingValueCommonResponse } from './system-setting-value.type';
import { adaptUserMetaUndefinedFromResponse } from './user-meta.type';


export type TSystemSettingShiftsNotCountingOverworkTime = TSystemSettingValueCommon & {
  value?: number;
};

export type TSystemSettingShiftsNotCountingOverworkTimeResponse = TSystemSettingValueCommonResponse & {
  value?: number;
};

export type TSystemSettingShiftsNotCountingOverworkTimePayload = {
	value?: number;
};

export type TSystemSettingShiftsNotCountingOverworkTimeRequest = {
	value?: number;
};

export function adaptSystemSettingShiftsNotCountingOverworkTimeFromResponse(data: TSystemSettingShiftsNotCountingOverworkTimeResponse): TSystemSettingShiftsNotCountingOverworkTime {
	const {
		public_id: publicId,
		name,
		value,
		description,
		created_at: createdAt,
		updated_at: updatedAt,
		created_by: createdByRaw,
		updated_by: updatedByRaw,
	} = data;

	const createdBy = adaptUserMetaUndefinedFromResponse(createdByRaw);
	const updatedBy = adaptUserMetaUndefinedFromResponse(updatedByRaw);

	return {
		publicId,
		name,
		value,
		description,
		createdAt,
		updatedAt,
		createdBy,
		updatedBy,
	};
}

export function adaptSystemSettingShiftsNotCountingOverworkTimeToRequest(data: TSystemSettingShiftsNotCountingOverworkTimePayload): TSystemSettingShiftsNotCountingOverworkTimeRequest {
	const { value = '' } = data;

	return {
		value: value ? value : undefined,
	};
}
